import axios from "axios";
import { useEffect, useState } from "react";
import "./Admin.css";

const Admin = () => {

  const [users, setUsers] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isAuth, setIsAuth] = useState(false);
  const [password, setPassword] = useState("");

  /* ================= LOGIN ================= */

  const handleLogin = async () => {

    try {
      const res = await axios.post("/api/admin-login", {
        password
      });

      if (res.data.success) {
        setIsAuth(true);
        localStorage.setItem("admin_auth", "true");
      }

    } catch {
      alert("Wrong password");
    }

  };

  useEffect(() => {
    if (localStorage.getItem("admin_auth")) {
      setIsAuth(true);
    }
  }, []);

  /* ================= API ================= */

  const startTest = async () => {
    await axios.post("/api/start-test");
  };

  const fetchData = async () => {

    try {
      setLoading(true);

      const [userRes, lbRes] = await Promise.all([
        axios.get("/api/reaction-users"),
        axios.get("/api/webinar-leaderboard")
      ]);

      setUsers(userRes.data.users || []);
      setLeaderboard(lbRes.data.leaderboard || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    if (!isAuth) return;

    fetchData();

    const interval = setInterval(fetchData, 3000);

    return () => clearInterval(interval);

  }, [isAuth]);

  /* ================= LOGIN UI ================= */

  if (!isAuth) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h2>🔐 Admin Login</h2>

        <input
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ padding: "10px", width: "250px" }}
        />

        <br /><br />

        <button onClick={handleLogin}>
          Login
        </button>
      </div>
    );
  }

  /* ================= ADMIN PANEL ================= */

  return (
    <div className="admin-container">

      <h2 className="admin-title">🎛 Admin Panel</h2>

      {/* Logout */}
      <button
        onClick={() => {
          localStorage.removeItem("admin_auth");
          window.location.reload();
        }}
        style={{ marginBottom: "10px" }}
      >
        Logout
      </button>

      <br />

      <button className="start-btn" onClick={startTest}>
        🚀 Start Test
      </button>

      <div className={`admin-grid ${loading ? "fade" : ""}`}>

        {/* USERS */}
        <div className="users-box">
          <h3>🏁 Competition Users ({users.length})</h3>

          <ul>
            {users.map((user, index) => (
              <li key={index}>{user.name}</li>
            ))}
          </ul>
        </div>

        {/* LEADERBOARD */}
        <div className="leaderboard-box">

          <h3>🏆 Leaderboard</h3>

          <table>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Best (ms)</th>
                <th>%</th>
              </tr>
            </thead>

            <tbody>
              {leaderboard.map((user, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{user.name}</td>
                  <td>{(user.bestReaction * 1000).toFixed(0)}</td>
                  <td>{user.percentile}%</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

      </div>

    </div>
  );
};

export default Admin;